const PAGINATION = {
  PAGE_INDEX: 0,
  PAGE_SIZE: 10,
};

export default PAGINATION;
